const usePrice = (price: Price, isGlobal: boolean = false) => {
    return {
        amount: (isGlobal && price.globalAmount) || price.amount,
        discountedPrice: isGlobal ? (price.globalDiscountedPrice || 0) : price.discountedPrice,
    }
};

export default usePrice;